import { PartnerAddressDto } from './partnerAddressDto';

export class UserDto{
    id:number;
    name:string;
    lastName:string;
    username:string;
    email:string;
    password:string;
    roles:any[];
    favoriteSites:number[];
    favoriteMonuments:number[];
    addresses:PartnerAddressDto[];
    sitePurchased:number[];
    image: string ='';
    virtualTourType: string;
}